<template>
  <div>
    <UIProgressCircular v-show="!dataLoaded" />

    <div v-show="dataLoaded" class="mt-4">
      <v-row class="my-0">
        <v-col cols="12" class="py-0">
          <v-card class="pa-4 base-card d-flex justify-space-between align-center">
            <h3>Новости</h3>

            <ButtonOutlineSmall
              v-if="isAdmin"
              title="Добавить"
              icon="plus"
              @click="dialog = true"
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row ref="list" class="my-0 mx-0 mt-4 overflow-auto">
        <v-col class="d-none d-sm-flex" sm="1" lg="2" xl="3" />
        <v-col cols="12" sm="10" lg="8" xl="6" class="pt-0 px-4">
          <v-list class="pt-0 transparent">
            <v-card v-for="(news, i) in newsList.list" :id="`new-${news.id}`" :key="i" class="mb-4 base-card">
              <v-card-text class="news-wrapper">
                <div class="custom-header mb-2 text-center">
                  {{ news.name }}
                </div>
                <div class="text-center">
                  <v-img class="custom-img" :src="news.src" width="800" style="" />
                <!--                  <p>{{ news.shortText }}</p>-->
                </div>

                <p>{{ news.fullText }}</p>

                <div class="d-flex justify-end buttons">
                  <div class="d-flex d-inline">
                    <!--                    Temporary unused as it repeat functionality of edit mode but only for reading-->
                    <!--                    <v-icon v-if="isOperatorRoles" class="mr-4 uikit-icon eye primary-h" title="Посмотреть" @click="show(news)" />-->
                    <v-icon v-if="isAdmin" class="mr-4 uikit-icon edit-icon success-h" title="Редактировать" @click="edit(news)" />
                    <v-icon v-if="isAdmin" class="uikit-icon trash error-h" title="Удалить" @click="remove(news)" />
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card v-if="!newsList.list.length" class="base-card">
              <v-card-title>Нет новостей</v-card-title>
            </v-card>
          </v-list>
        </v-col>
        <v-col class="d-none d-sm-flex" sm="1" lg="2" xl="3" />
      </v-row>
    </div>

    <NewsDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @saveNews="saveNews"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeNews"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import { NewsList } from '@/models'
import { newsApi, fileApi } from '@/api'
import {
  cloneDeep,
  debounce,
} from 'lodash'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import NewsDialog from '@/components/Spm/NewsPage/dialogs/NewsDialog'
import { mapGetters } from 'vuex'
import ButtonOutlineSmall from '@/featureSlicedDesign/shared/ui/ButtonOutlineSmall'

export default {
  name: 'EventsPage',

  metaInfo: { title: 'Новости' },

  components: {
    ButtonOutlineSmall,
    NewsDialog,
    UIProgressCircular,
    ConfirmDialog,
  },

  async created() {
    await this.getNewsList()
    this.dataLoaded = true
  },

  mounted() {
    this.setListHeight()
    window.addEventListener('resize', this.setListHeight)

    setTimeout(() => {
      const newId = this.$route.query.idNew
      if (newId) {
        const element = document.getElementById(`new-${newId}`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    }, 500)
  },

  destroyed() {
    window.removeEventListener('resize', this.setListHeight)
  },

  data: () => ({
    newsList: new NewsList(),

    tableHeaders: [
      { text: 'id', value: 'id', sortable: false, align: 'start' },
      { text: 'Название', value: 'name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'end', width: '180px' },
    ],

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
  }),

  computed: { ...mapGetters('user', ['isOperatorRoles', 'isAdmin']) },

  methods: {
    showSearch() {
      this.isShowSearch = !this.isShowSearch
      this.isShowFilter = false
      this.setTableHeight()
    },

    showFilter() {
      this.isShowFilter = !this.isShowFilter
      this.isShowSearch = false
      this.setTableHeight()
    },

    async getNewsList() {
      try {
        this.tableLoading = true

        const content = await newsApi.getCatalog()
        this.newsList = new NewsList()

        content.length && content.forEach((obj) => this.newsList.add(obj))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения новостей')
      } finally {
        this.tableLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async saveNews(body, file) {
      try {
        this.saveBtnLoading = true
        let data = body
        if (!data?.id) {
          data = await newsApi.create(data)
          this.newsList.add(data)
        }

        let fileData = null
        if (file && !('refClassName' in file)) {
          fileData = await fileApi.postFiles([file], data.id, 'news')
        }

        if (fileData) data.files = fileData
        data = await newsApi.update(data)
        this.newsList.update(data)

        this.$toastr('success', '', 'Новость успешно сохранена')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeNews() {
      try {
        this.removeLoading = true
        await newsApi.remove(this.selectedItem.id)
        this.newsList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    setListHeight() {
      this.$nextTick(() => {
        if (this.$refs?.list) {
          const footerHeight = 67
          const topHeight = this.$refs.list.getBoundingClientRect().top

          this.$refs.list.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
      }
    },

    setFilters: debounce(async function debounceSetFilters(filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },
  },

  watch: {
    dataLoaded() {
      this.setListHeight()
    },

    filters: {
      deep: true,
      async handler() {
        this.pageNumber = 0
        this.lastPage = false
        this.total = 0
        await this.getEventList()
      },
    },

    '$route.query': {
      immediate: true,
      handler() {
        const newId = this.$route.query.idNew
        if (newId) {
          const element = document.getElementById(`new-${newId}`)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
.news-wrapper {
  .custom-header {
    font-size: 18px;
    font-weight: 700;
  }
  :after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    height: 0;
  }
}
</style>
